import { FusionEnvironment } from "./app.models";

export const Environment: FusionEnvironment = 'development';
export const CloudwatchGroup = `arn:aws:logs:us-east-1:578736327768:log-group:/aws/lambda/FusionFn-Dev`;
export const UserInputDebounceTime = 200;
export const SnackbarDuration = 3000;

export const RouteNames = {
  TemplateList: 'Template List',
  EditTemplate: 'Edit Template',
  AnalyticsRawData: 'Analytics Raw Data'
};

export const Storage = {
  IdToken: 'id_token',
  AccessToken: 'access_token',
  RefreshToken: 'refresh_token',
  MssqlCompanyId: 'mssql_company'
};

export const Messages = {
  NoToken: 'No token found in storage',
  TemplateInfoSaved: 'Template info was successfully saved',
  VersionInfoSaved: 'Version info was successfully saved',
  VersionReleased: 'Version was successfully released',
  ConfirmRelease: 'Are you sure you want to release this template? \n\nYou cannot edit a template after it has been released',
  TemplateIdCopied: 'Template ID has been copied to the clipboard',
  TemplateSaveError: 'An error occurred saving template data',
  ClipboardCopy: 'Item has been copied to the clipboard'
};

export const Ace = {
  keyboardStorageKey: 'ace_keyboard',
  defaultKeyboard: 'default',
  basePath: 'https://unpkg.com/ace-builds@latest/src-noconflict',
  theme: 'ace/theme/textmate'
};

export const SkyPgDatabases = [
  { name: 'Grower360', dev: 'grower360_dev', prod: 'grower360_production' },
  { name: 'Payment', dev: 'PaymentDev', prod: 'PaymentProd' },
  { name: 'SKYDentity', dev: 'skydentity-dev', prod: 'skydentity' },
  { name: 'Analytics Datasource Catalog', dev: 'AnalyticsDatasourceCatalog', prod: 'AnalyticsDatasourceCatalog' },
  { name: 'Analytics Trace', dev: 'AnalyticsTrace', prod: 'AnalyticsTrace' },
  { name: 'Applicator Filters', dev: 'ApplicatorFilters', prod: 'ApplicatorFilters' },
  { name: 'Cash Bids', dev: 'CashBidApiDev', prod: 'CashBidApiProd' },
  { name: 'Chat Messages', dev: 'ChatMessages', prod: 'ChatMessages' },
  { name: 'Crop Chemistry Location', dev: 'CropChemistryLocation', prod: 'CropChemistryLocation' },
  { name: 'Crop Filters', dev: 'CropFilters', prod: 'CropFilters' },
  { name: 'Dispatch Logging', dev: 'DispatchLogsDev', prod: 'DispatchLogsProd' },
  { name: 'Dispatch Priorities', dev: 'DispatchPriorities', prod: 'DispatchPriorities' },
  { name: 'Dispatch User Filters', dev: 'DispatchUserFilters', prod: 'DispatchUserFilters' },
  { name: 'Grower360 Logging', dev: 'grower360log_dev', prod: 'grower360log_production' },
  { name: 'Job Assignments', dev: 'JobAssignments', prod: 'JobAssignments' },
  { name: 'Location Filter Service', dev: 'LocationFilterService', prod: 'LocationFilterService' },
  { name: 'Mapping', dev: 'MappingDev', prod: 'MappingProd' },
  { name: 'Messaging', dev: 'messagingapi-dev', prod: 'messagingapi-prod' },
  { name: 'MobileData', dev: 'MobileDataDev', prod: 'MobileDataProd' },
  { name: 'Notifications', dev: 'NotificationsDev', prod: 'NotificationsProd' },
  { name: 'Patronage', dev: 'PatronageDev', prod: 'PatronageProd' },
  { name: 'Permissions', dev: 'PermissionsDatabaseDev', prod: 'PermissionsDatabaseProd' },
  { name: 'Sky Applicator', dev: 'SkyApplicatorService', prod: 'SkyApplicatorService' },
  { name: 'Sky User Analytics', dev: 'SkyUserAnalyticsDatabaseDev', prod: 'SkyUserAnalyticsDatabaseProd' },
  { name: 'Sky Other', dev: 'SkyOther', prod: 'SkyOther' },
  { name: 'Sky Permissions', dev: 'SkyPermissionsDev', prod: 'SkyPermissionsProd' },
  { name: 'User Notification', dev: 'UserNotificationApiDev', prod: 'UserNotificationApiProd' },
  { name: 'Utility', dev: 'Utility', prod: 'Utility' },
  { name: 'Fusion', dev: 'fusion', prod: 'fusion' },
  { name: 'Sky Data Hub', dev: 'SkyDataHub', prod: 'SkyDataHub' }
];

export const FusionTemplates = {
  AnalyticsUsage: 'ef7386be-2464-4063-9f64-2ed8da1eb2bc',
  AnalyticsExcluded: '48cb1110-cebf-469a-8e45-127a68878d66',
  AnalyticsApplicationList: 'efc7b377-d63e-48f0-a74b-686dd5322c07',
  AnalyticsRawData: 'bfb978d4-253c-4aed-a57a-5f0302e44827',
  AnalyticsUserTypes: 'be748e31-3f22-497b-a785-c1c485e332fc',
  ReleaseTemplate: '0de969c3-0c2d-4d5d-a063-0dca675bb32b',
  DeleteTemplate: '182ef912-4e57-4246-a193-93e2107469b2',
  GetTemplate: 'aa4a470f-117e-4258-89ac-3fba3aa9977e',
  UserSession: 'ca6424a7-305c-4fb5-acd1-9c00565faf2a',
  InsertTemplate: '9f23ab23-787f-46c5-b5c9-3b01339b9547',
  CopyTemplate: '56fef4f4-724b-4149-87c5-231cc4862a7d',
  PatchTemplate: '7e335828-8351-476e-9083-19c3665fe854',
  GetTemplateParams: 'c2f98381-9457-4a40-8ef9-1c2e9c28ba4e',
  SaveTemplateParams: '0868114c-453c-494a-ae82-fc8fddc2c0d4',
  ListTemplates: 'e2804fc4-0312-4de4-a4cc-95d7af6b996b',
  TemplateOwnerList: 'a45cb5e5-c26e-4802-ba18-88704d8152f7',
  QueryTemplateList: '3d3d25e3-b243-4394-a8e8-3bbefa911317'
};

export const Cognito = {
  url: 'https://sky-devs.auth.us-east-1.amazoncognito.com',
  clientId: '4lrprf3m2kppjm3mi7r815ssis',
  identityProvider: 'SSIAzureAD',
  responseType: 'code'
};

export const IdentityPool = {
  region: 'us-east-1',
  identityPoolId: 'us-east-1:bd128213-7336-4959-acff-9f525ac1bbd9',
  userPoolId: 'us-east-1_Vg8X2mHna',
  AgvanceSkyAccountId: '401025183595',
  AgvanceAccountRoleArn: 'arn:aws:iam::578736327768:role/AgvanceSky_DeveloperIdPool'
};

export const whenDefined = (fn: () => any | undefined, timeout = 2000, polling = 50): Promise<any> => {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const interval = setInterval(() => {
      const val = fn();
      if (val !== undefined) {
        clearInterval(interval);
        resolve(val);
      }

      const now = Date.now();
      if (now - start >= timeout) {
        clearInterval(interval);
        reject(new Error('timeout'));
      }
    }, polling);
  });
};
